module.exports = __webpack_public_path__ + "img/noir.9f16ee10.png";